export default "__VITE_ASSET__bc359a05__"